module.exports = __webpack_public_path__ + "static/content_text_equivalents_5_eg-df49a6be392a2658cb255fbba494b8dc.png";